// extracted by mini-css-extract-plugin
export default {"regexInputContainer":"DefinitionRegexEditor-module__regexInputContainer--a9jfi","testRegexButton":"DefinitionRegexEditor-module__testRegexButton--S9buT"};